//表格中后端代码转文字
export function codeToText(data, obj) {
  if (!obj || !(obj.constructor == Object || obj.constructor == Array))
    throw new Error('codeToText第二个参数需传入对象或数组')
  return obj[data] || ''
}

//单词首字母大写
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

//后端数据转option
export function dataToOptions(data, config) {
  const { label = 'name', value = 'id', keepOtherData = false } = config
  if (data.constructor !== Array) throw new Error('dataToOptions需传入数组')
  if (keepOtherData)
    return data.map((item) => ({
      label: item[label],
      value: item[value],
      ...item,
    }))
  return data.map((item) => ({
    label: item[label],
    value: item[value],
  }))
}

//后端数据转data-source
export function dataToDataSource(data, config) {
  const { title = 'name', key = 'id', keepOtherData = false } = config
  if (data.constructor !== Array) throw new Error('dataToOptions需传入数组')
  if (keepOtherData)
    return data.map((item) => ({
      title: item[title],
      key: item[key],
      ...item,
    }))
  return data.map((item) => ({
    title: item[title],
    key: item[key],
  }))
}

//常量对象转option
export function constantToOptions(constant, config = {}) {
  const { inValue = false, getName = false, filterNegative = false } = config

  if (constant?.constructor === Array)
    return constant.map((item, index) => {
      if (item.constructor === String)
        return getName
          ? { label: item, value: item }
          : { label: item, value: index }
    })

  if (constant?.constructor === Object) {
    const constantCp = { ...constant }
    if (filterNegative) delete constantCp[-1]
    return Object.keys(constantCp).map((key, index) => {
      const value = constantCp[key]
      if (inValue)
        return getName
          ? { label: value.value.toString(), value: value.value.toString() }
          : { label: value.value.toString(), value: key }
      if (value.constructor === String)
        return getName
          ? { label: value.toString(), value: value.toString() }
          : { label: value.toString(), value: key + '' }
    })
  }

  throw new Error('constantToOptions需传入数组或对象')
}

//后端数据转枚举类型
export function resListToEnum(list, config = {}) {
  const {
    toString = false,
    saveData = false,
    idName = 'id',
    valueName = 'name',
  } = config
  const obj = {}
  if (list.constructor !== Array)
    throw new Error('resListToEnum后端数据转枚举类型需传入数组')
  list.forEach((item) => {
    obj[toString ? item[idName] + '' : item[idName]] = saveData
      ? item
      : item[valueName]
  })
  return obj
}
